
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/central-de-ajuda/chatbot",
      function () {
        return require("private-next-pages/central-de-ajuda/chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/central-de-ajuda/chatbot"])
      });
    }
  